import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import keymaster from 'keymaster';
import { Label, Modal } from 'react-bootstrap';

class ConfirmationModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        ReactDOM.findDOMNode(this.refs.confirmButton).focus();
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
        this.props.returnKeymaster();
    }

    handleConfirm = () => {
        this.props.handleConfirm();
        this.handleClose();
    }

    handleRefocus = () => {
        ReactDOM.findDOMNode(this.refs.confirmButton).focus();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Change timesheet status</h4>
                        </div>
                        <div className="modal-body text-center">
                            <div className="row">
                                Currently logged: <Label className={this.props.hoursLogged != this.props.quota ? "label-danger" : null}>{this.props.hoursLogged}h {this.props.minutesLogged ? this.props.minutesLogged + "min" : ""}</Label>
                            </div>
                            <div className="row">
                                Weekly quota: <Label>{this.props.quota}h</Label>
                            </div>
                            <div className="row">
                                Mark timesheet as {this.props.status}?
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" ref="confirmButton" disabled={this.props.hoursLogged != this.props.quota} onClick={this.handleConfirm} className="btn btn-default btn-large">Yes</button>
                            <button type="button" ref="closeButton" onBlur={this.handleRefocus} onClick={this.handleClose} className="btn btn-default btn-discrete">Close</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

ConfirmationModal.propTypes = {
    returnKeymaster: PropTypes.func,
    hoursLogged: PropTypes.number,
    minutesLogged: PropTypes.number,
    quota: PropTypes.number,
    handleClose: PropTypes.func,
    handleConfirm: PropTypes.func,
    status: PropTypes.string
};

export default connect()(ConfirmationModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/ConfirmationModal.js
 **/